import {createContext} from 'preact';
import {useCallback, useEffect, useState} from 'preact/hooks';

export const LoadingContext = createContext();

// Module-level so pages/+onPageTransitionStart.js and
// +onPageTransitionEnd.js (plain Vike hooks, outside the Preact tree) can
// drive the same bar the manual setLoading() call sites already use.
const listeners = new Set();

export function reportLoadingStart() {
    listeners.forEach((setLoading) => setLoading(true));
}

export function reportLoadingEnd() {
    listeners.forEach((setLoading) => setLoading(false));
}

export function LoadingProvider({children}) {
    // A counter, not a bool: page transitions and manual fetch-then-navigate
    // call sites (Header's random song/favorites, AccountSidebar) can
    // overlap, and the bar must stay up until every source that started it
    // has also finished.
    const [count, setCount] = useState(0);

    const setLoading = useCallback((isLoading) => {
        setCount((current) => Math.max(0, current + (isLoading ? 1 : -1)));
    }, []);

    useEffect(() => {
        listeners.add(setLoading);
        return () => listeners.delete(setLoading);
    }, [setLoading]);

    return (
        <LoadingContext.Provider value={{loading: count > 0, setLoading}}>
            {children}
        </LoadingContext.Provider>
    );
}
